import React, {useEffect, useState} from 'react';
import UnloginPopup from '../../components/UnloginPopup';

import {
   Image,
} from 'semantic-ui-react';

import {Link, useLocation} from "react-router-dom";

import "./style.css"
import {useDispatch, useSelector} from "react-redux";

import DescIcon  from '../../icons/desc-congress-icon.png';
import { ReactComponent as ArrowForTicket } from '../../icons/arrow-for-ticket.svg';
import ExpositionIcon  from '../../icons/exposition-icon.png';
import BusIcon  from '../../icons/business-program-icon.png';
import CulIcon  from '../../icons/cultural-program-icon.png';
import ExhibitionIcon  from '../../icons/exhibition-icon.png';

import AsiaMeet from '../../icons/asiameet-icon-for-home.png'
import ArchiveIcon  from '../../icons/archive-events-icon.png';
import EventsIcon  from '../../icons/events-icon.png';
import {setWindowScrollPosition} from "../../components/WindowDimensions";
import {getLanguage} from "../../components/LanguageModal/reducer";
import translations from "../../components/LanguageModal/translations";
import {toastr} from "react-redux-toastr";
import QrIcon from "../../icons/qr-icon.png";
import {getTypeExhibition} from "./reducer";
import {setTypeExhibition} from "./actions";
import DropdownComponent from "../../components/DropdownComponent";
import {Button, Dropdown, Space} from 'antd';
import { DownOutlined } from '@ant-design/icons';




export default function Home (props) {
    const { navigate, token } = props;
    const dispatch = useDispatch();
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
        if(location.state?.meetUnLogin){
            setOpenLogin(location.state?.meetUnLogin);
        }
        if(location.state?.scanUnLogin){
            setOpenLogin(location.state?.scanUnLogin);
        }

    }, []);

    const language = useSelector(getLanguage);
    const languageString = language[0]+language[1];
    const t = (key) => {
        const translation = translations[languageString];
        return translation ? translation[key] || key : key;
    };
    const typeExhibition = useSelector((state) => getTypeExhibition(state.exhibition));
    const dataExhibitions = {
        asia: {
            colorGradient: 'linear-gradient(to right,#d81524,#871c1c)',
        },
        gras: {
            colorGradient: 'linear-gradient(90deg, #037C00 0%, #035700 100%)',
        }
    }

    const [openLogin, setOpenLogin] = useState(false);

    const handleClickScan = () => {
        if (token) {
            navigate('/scan')
        } else {
            setOpenLogin(true);
        }
    }

    const handClickAsiameet = () => {
        if (token) {
            navigate('/asiameet')
        } else {
            setOpenLogin(true);
        }
    }

    const options = [{
        key: 'gras', label: 'GRAS 2025',
    }, {
        key: 'asia', label: 'ASIAEXPO 2026',
    }]

    const handleMenuClick = ({ key }) => {
        dispatch(setTypeExhibition({ type: key }));
    };

      return (
          <>

     <div className="main-block">
         <Dropdown menu={{ items: options, onClick: handleMenuClick }}>
             <Button
                 style={{
                     background: dataExhibitions[typeExhibition].colorGradient,
                 }}
                 className='home-dropdown no-hover-button'
             >
                 <div style={{
                     display: 'flex',
                     justifyContent: 'space-between',
                     alignItems: 'center',
                     width: '100%',
                 }}>
                     <span>{typeExhibition === 'gras' ? 'GRAS 2025' : "ASIAEXPO 2026"}</span>
                     <DownOutlined />
                 </div>
             </Button>
         </Dropdown>
         <div className="container-ticket">
             <Link className={`ticket ${typeExhibition}`} to='/ticket'>
                 <Image src='https://cms.asiaexpo.space/wp-content/uploads/2024/07/ticket-icon.png' className='desc-icon'/>
                  <div className="text-for-ticket">{t('eticket')} <br/> {t('ticket')}</div>

                  <ArrowForTicket className="arrow-icon-1"/>
              </Link>
          </div>
         <div className="main-container">
             <div className="container-cards">
                 <Link className={`icontab ${typeExhibition}`} to='/description-congress'>
                     <img src={DescIcon}/>
                 </Link>
                 <Link className="label-for-icon" to='/description-congress'>
                     <p className="text-for-icon">{t('descCongress')}</p>
                 </Link>
             </div>

             {typeExhibition === 'asia' && <div className="container-cards">
                 <Link className={`icontab ${typeExhibition}`} to='/exposition'>
                     <img src={ExpositionIcon}/>
                 </Link>
                 <Link className="label-for-icon" to='/exposition'>
                     <p className="text-for-icon">{t('exposition')}</p>
                 </Link>
             </div>}

             <div className="container-cards">
                 <div className={`icontab ${typeExhibition}`} onClick={() => navigate('/business-program')}>
                     <img src={BusIcon}/>
                 </div>
                 <div className="label-for-icon" onClick={() => navigate('/business-program')}>
                     <p className="text-for-icon">{t('busProgram')}</p>
                 </div>
             </div>

             {/*<div className="container-cards">*/}
             {/*    <Link className={`icontab ${typeExhibition}`} to='/cultural-program'>*/}
             {/*        <img src={CulIcon}/>*/}
             {/*    </Link>*/}
             {/*    <Link className="label-for-icon" to='/cultural-program'>*/}
             {/*        <p className="text-for-icon">{t('culProgram')}</p>*/}
             {/*    </Link>*/}
             {/*</div>*/}
             <div className="container-cards">
                 <div className={`icontab ${typeExhibition}`} onClick={() => navigate('/exponents')}>
                     <img src={ExhibitionIcon}/>
                 </div>
                 <div className="label-for-icon" onClick={() => navigate('/exponents')}>
                     <p className="text-for-icon">{t('exhibitors')}</p>
                 </div>
             </div>
             <div className="container-cards">
                 <div className={`icontab ${typeExhibition}`} onClick={() => handClickAsiameet()}>
                     <img src={AsiaMeet}/>
                 </div>
                 <div className="label-for-icon" onClick={() => handClickAsiameet()}>
                     <p className="text-for-icon">{t('matchmaking')}</p>
                 </div>
             </div>


                 {/*<div className="container-cards">*/}
                 {/*    <Link className={`icontab ${typeExhibition}`} to='/archive-events'>*/}
                 {/*        <img src={ArchiveIcon}/>*/}
                 {/*    </Link>*/}
                 {/*    <Link className="label-for-icon" to='/archive-events'>*/}
                 {/*        <p className="text-for-icon">{t('archiveEvents')}</p>*/}
                 {/*    </Link>*/}
                 {/*</div>*/}
             <div className="container-cards">

                 <div className={`icontab ${typeExhibition}`} onClick={() => handleClickScan()}>
                     <img src={QrIcon}/>
                 </div>
                 <div className="label-for-icon" onClick={() => handleClickScan()}>
                     <p className="text-for-icon">{t('qrCode')}</p>
                 </div>
             </div>

         </div>
         <UnloginPopup open={openLogin} setOpen={setOpenLogin} text={t('onlyReg')} />
         {/*<span className='info-ae2025-text'>{t("infoAE2025")}</span>*/}
     </div>
          </>
      );
}